import { NotificationStatusEnum } from '@ztechapps/common.contract'

//TOOD: Update this
export const NotificationStatus = {
  Draft: {
    value: NotificationStatusEnum.unread,
    description: 'The project have not started yet',
    sort: 0,
    color: '#7f8692',
  },
}
